export const veridionPageBG = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | Организация от ИИ служители",
    "description": "Следващото стъпало на производителността: Organisation as a Service. Организация от ИИ служители доставя проверена работа, планируема във фиксирани цикли, на място или във Вашия собствен облак."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Един създател, безкрайно много решения.",
    "claim": "Следващото стъпало на производителността: Organisation as a Service.",
    "lead": "Фирменият ИИ, който управлява цялата pAIoneer Labs GmbH: работна сила от ИИ, която се интегрира във всеки процес на Вашата компания, самостоятелно довежда работата докрай и се учи с всяка задача. Хората задават посоката. Всичко останало се случва от само себе си."
  },
  "vision": {
    "lines": [
      "Софтуерът даде на компаниите инструменти.",
      "ИИ им даде асистенти.",
      "Veridion им дава организация."
    ],
    "note": "Информацията се движи за часове, опитът се пенсионира, позициите остават незаети. Още един инструмент не решава това; решава го работна сила, която не е нужно да наемате."
  },
  "grow": {
    "title": "Каквото не умее, го създава",
    "text": "Когато за дадена задача все още не съществува способност или нещо не може да се реши с наличните средства, Veridion сам разработва нови, произволно сложни ИИ системи — ИИ сам развива ИИ нататък: проектирани, изградени, проверени и пуснати в експлоатация. Единствено одобрението остава при човека чрез [Intent-Driven Development](idd) (IDD).",
    "punch": "Точно това означава: един създател, безкрайно много решения."
  },
  "integrate": {
    "title": "В самата среда на Вашите процеси",
    "subtitle": "Без нов софтуер, без обучение, без миграция.",
    "cards": [
      {
        "title": "Във фирмения чат",
        "text": "Разговорът се води там, където Вашите хора и без това пишат: Webex, Microsoft Teams, Zoom, Slack. Едно съобщение стига."
      },
      {
        "title": "Във Вашите инструменти",
        "text": "Управление на проекти, repositories, архиви: работи се в системите, които вече са налице, а не покрай тях."
      },
      {
        "title": "От офертата до счетоводството",
        "text": "Един процес след друг, с Вашето темпо. Когато капацитетът недостига, също и само отделен пакет за разработка или цял проект."
      }
    ]
  },
  "org": {
    "title": "Работна сила, организирана като компания",
    "subtitle": "Ние не налагаме твърд шаблон на никоя компания: за всяка фирмена структура проектираме индивидуална органиграма, задаваме ясни роли и отговорности и се адаптираме гъвкаво. Всяко бизнес звено се състои от ИИ служители, оркестрирани от Veridion, които работят напълно автоматизирано чак до [IDD](idd) Human-in-the-Loop — а когато нещо все още не е възможно, Veridion сам разработва нов ИИ.",
    "execKicker": "Координационно ниво — напълно автоматизирано до IDD Human-in-the-Loop",
    "execTitle": "Индивидуална органиграма, ясни роли и ИИ, който сам развива ИИ.",
    "execText": "Под хората, вземащи решения, координационното ниво и бизнес звената от ИИ служители работят напълно автоматизирано: те декомпозират целите, разпределят работата по ясно дефинирани роли и отговорности, решават проблеми самостоятелно и изискват целенасочени одобрения от човека. Човекът в цикъла управлява чрез [Intent-Driven Development](idd) (IDD) — далеч отвъд софтуерния код като съвместно управление на човек и ИИ чрез намерения, решения и сценарии за проверка. И винаги когато липсва дадена способност, Veridion самостоятелно проектира и изгражда нови, произволно сложни ИИ системи — ИИ развива ИИ нататък.",
    "units": [
      {
        "name": "Разработка на софтуер",
        "text": "Отговаря за софтуера от изискването до експлоатацията: архитектура, код, тестове, ревюта, конвейери и качеството зад тях."
      },
      {
        "name": "Електроника и фърмуер",
        "text": "Отговаря за хардуерната страна: схеми, фърмуер и изборът на всеки компонент."
      },
      {
        "name": "Квантови изчисления и квантов ИИ",
        "text": "Отговаря за изследванията върху квантовите изчисления и квантовия ИИ и превръща надеждните резултати в продукти."
      },
      {
        "name": "Продажби и маркетинг",
        "text": "Отговаря за пазара: наблюдава го, намира целеви клиенти, изготвя досиета, съставя текстове и оферти. Сделката сключва човек."
      },
      {
        "name": "Продукти и експлоатация на платформата",
        "text": "Отговаря за продуктите и експлоатацията: стратегия, приоритети, издания, заедно с наблюдение, инциденти и капацитет на работещата платформа."
      },
      {
        "name": "Администрация и финанси",
        "text": "Отговаря за административната и финансовата страна: първични документи, фактури, договори, срокове, подготвени до подписа, а той остава при Вас."
      }
    ]
  },
  "trust": {
    "title": "На какво можете да разчитате",
    "cards": [
      {
        "title": "Human-in-the-Loop и IDD далеч отвъд програмния код",
        "text": "Intent-Driven Development ([IDD](idd)) е много повече от писане на софтуерен код: това е онова, което човекът в цикъла прави заедно с ИИ във всички сфери на компанията. Човекът и ИИ заедно формулират намерението (Intent), вземат обвързващи решения (Decisions) и дефинират проверими сценарии (Scenarios), преди ИИ екипът да изпълни работата самостоятелно във фиксирани, планируеми цикли с човешко одобрение."
      },
      {
        "title": "Комуникация, оптимизирана чрез теория на игрите",
        "text": "Управлението на проекти и комуникацията на ИИ служителите са оптимизирани чрез теория на игрите, от отделния ИИ служител до цялото бизнес звено: задълбочеността и обоснованото възражение се отплащат; формалното одобряване, повторението и прехвърлянето на отговорност струват. Така се налага най-добрата комуникация."
      },
      {
        "title": "Обяснима до източника",
        "text": "Explainable AI тук е работен принцип, а не добавка: всеки резултат разкрива от какво е възникнал — пасажите във фирмените знания, данните, изчислителния път. Каквото няма доказателство, не се твърди."
      },
      {
        "title": "Учи се самостоятелно",
        "text": "Собствените показатели се четат след всяко изпълнение, а собствените правила се коригират спрямо тях: всеки текущ проект прави цялото по-добро."
      }
    ]
  },
  "daily": {
    "title": "Какво се поема още днес",
    "subtitle": "Всеки ден, из цялата компания.",
    "items": [
      {
        "title": "Разработка",
        "text": "Код, тестове и документация от записани решения. Модернизация на израснал софтуер с доказателства golden master и back-to-back."
      },
      {
        "title": "Електроника и фърмуер",
        "text": "Анализиране на datasheets, симулиране на схеми като дигитални близнаци, разработване на фърмуер и преценка на алтернативи за компонентите, преди нещо да бъде произведено, близо до хардуера — чак до сензора."
      },
      {
        "title": "Квантови изследвания",
        "text": "Четене на актуалното състояние на техниката, изграждане и оценяване на възпроизводими експерименти срещу класически бази за сравнение, всеки резултат — записан проследимо."
      },
      {
        "title": "Анализ на данни",
        "text": "SQL Server, MariaDB, MySQL и Oracle: типизиран план за анализ, изключително четящи заявки, статистика от средата за изпълнение, отчети от един версиониран резултат."
      },
      {
        "title": "Администрация и финанси",
        "text": "Счетоводство, финансова отчетност и бюрокрацията на едно дружество: четене, разпределяне и архивиране на първични документи; включително чернови на фактури и договори."
      },
      {
        "title": "Проекти и задачи",
        "text": "От транскрипцията на една среща без заобикалки стават задачи в управлението на проекти, а напредъкът се връща обратно: следващата среща започва от актуалното състояние."
      },
      {
        "title": "Фирмени знания",
        "text": "База знания за документи и графова база данни, която свързва задачи, решения, хора и системи: контекст през седмици и отвъд границите на проектите."
      },
      {
        "title": "Проучване в интернет",
        "text": "Каквото фирмените знания нямат, се проучва: търси се, четат се най-добрите страници, а накрая стои доклад, в който всяко твърдение има своя номериран източник."
      },
      {
        "title": "Глас и срещи",
        "text": "Цялата фирма може да се ръководи мобилно: гласовите разговори вършат същата работа като чата, също и в движение по телефона."
      },
      {
        "title": "Офис работа с RoBuddy",
        "text": "RoBuddy покрива работното място: срещи, имейли, обучения и въпроси за защита на данните. Звената покриват останалата част от компанията."
      }
    ]
  },
  "operate": {
    "title": "Внедряване и експлоатация",
    "cards": [
      {
        "title": "На място или в собствен облак",
        "text": "Предварително изчисляваме заедно кои процеси си струват: възвръщаемостта на инвестицията и общите разходи са прозрачни. Експлоатацията върви върху Вашия хардуер или във Вашия собствен облак, без нито един документ да напусне компанията."
      },
      {
        "title": "При нас",
        "text": "pAIoneer Labs GmbH е изградена из основи по този начин: нашите проекти, нашите фирмени знания и нашата администрация вървят върху нея. Организацията сама разработва [трейдинг асистента](finance) на нашата платформа и е ИИ в неговия чат."
      }
    ]
  },
  "cta": {
    "title": "Запитване",
    "subtitle": "Като сървърен софтуер във Вашата инфраструктура. Цената съобщаваме при запитване.",
    "button": "Изпратете запитване",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
